import styled from "styled-components";
import { colors } from "../../consts";

export const PagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
  width: min-content;
  padding-right: 24px;
`;

export const TabItem = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: ${colors.RAISIN_80};
  padding: 0 12px 11px;
  position: relative;

  ${(props) =>
    props.isActive &&
    `font-weight: 700;
    color: ${colors.RAISIN_100};
  `}

  &::after {
    content: ${(props) => (props.isActive ? "''" : "unset")};
    width: 100%;
    height: 2px;
    background-color: ${colors.RAISIN_100};
    position: absolute;
    bottom: -2px;
    left: 0;
  }
`;